import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';

const Almoxarifado = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [showModal, setShowModal] = useState(false); // Controla a exibição do modal
  const [orderArray, setOrderArray] = useState([]); // Armazena os itens confirmados
  const [isSubmitting, setIsSubmitting] = useState(false);


  // Verifica navegação e bloqueio ao sair da página
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Verifica se há algum item com quantidade
      const hasQuantity = Object.values(order).some((quantity) => quantity > 0);

      if (hasQuantity) {
        event.preventDefault();
        event.returnValue = ''; // Necessário para que o navegador mostre o alerta padrão
      }
    };

    // Adiciona o evento antes de sair da página
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      // Remove o evento ao desmontar o componente
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [order]);

  // Navega para a página inicial se usuário não estiver logado
  useEffect(() => {
    // Verifica se `userInfo` está vazio e força o redirecionamento
    if (!userInfo?.username || !userInfo?.company) {
      // Limpa qualquer dado residual do estado (se necessário)
      localStorage.removeItem('userInfo'); // Limpeza do localStorage, caso aplicável
      navigate('/home'); // Redireciona para a tela inicial (Home)
    }
  }, [userInfo, navigate]);

  // Carrega os grupos e os produtos
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await fetch(`${userInfo.url}/departamentoprod/classe/${userInfo.dpc_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },
        });
        const data = await response.json();
        setGroups(data);
      } catch (error) {
        console.error('Erro ao buscar grupos:', error);
      }
    };

    const fetchProducts = async () => {
      try {
        const response = await fetch(`${userInfo.url}/departamentoprod/departamento/${userInfo.dpc_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },
        });
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      }
    };

    fetchGroups();
    fetchProducts();
  }, [userInfo]);

  // Filtra os produtos com base no grupo selecionado
  useEffect(() => {
    if (selectedGroup) {
      const filtered = products.filter(
        (product) => product.classe === selectedGroup
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [selectedGroup, products]);

  // Funções de alteração de estado
  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  const incrementQuantity = (productId) => {
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: (prevOrder[productId] || 0) + 1,
    }));
  };

  const decrementQuantity = (productId) => {
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: Math.max((prevOrder[productId] || 0) - 1, 0),
    }));
  };

  const handleQuantityChange = (productId, value) => {
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: Math.max(parseInt(value, 10) || 0, 0),
    }));
  };
  
      const confirmOrder = () => {
        const newOrderArray = Object.entries(order)
          .map(([productId, IALM_QTD]) => {
            const product = products.find((p) => p.id === parseInt(productId, 10));
            if (!product) {
              console.error(`Produto não encontrado para o ID: ${productId}`);
              return null; // Evita o erro caso o produto seja undefined
            }
            return {  IALM_DESCRICAO: product.name,
                      name: product.name,
                      IALM_QTD : IALM_QTD * (product.volume || 1),
                      IALM_STATUS: 'Pendente',
                      PRO_ID: product.id,
                      volume: product.volume,
                      embUnidade: product.embUnidade
                    };
          })
          .filter((item) => item && item.IALM_QTD > 0); // Certifique-se de filtrar itens válidos
      
        console.log(newOrderArray); // Verifique os dados aqui
      //id do modal
      //<span className="item-id">ID: {item.id}</span>
      
    if (newOrderArray.length === 0) {
      alert('Nenhum produto no pedido.');
      return;
    }
  
    setOrderArray(newOrderArray); // Atualiza os itens confirmados
    setShowModal(true); // Exibe o modal
  };  

  const hoje = new Date();
  const dataFormatada = `${hoje.getDate()}.${hoje.getMonth() + 1}.${hoje.getFullYear()}`;
  //console.log(dataFormatada); // Exibe algo como "27/3/2025"

  const sendOrderToAPI = async () => {
    if (isSubmitting) return; // Evita múltiplos envios
    setIsSubmitting(true);
    try {
      const payload = {
        ALM_DESCRICAO: 'APP ALMOX. - PEDIDO DE MATERIAL ' + userInfo.company,
        ALM_DTA_REGISTRO: dataFormatada,
        ALM_DTA_CADASTRO: dataFormatada,
        FOR_ID_ORIG: 3087,
        DPC_ID: userInfo.dpc_id,
        FUN_ID: userInfo.id,
        FUN_ID_SOLIC: userInfo.id,
        ALM_STATUS: 'Pendente',
        USU_ID: userInfo.id,
        ITEM_ALMOXARIFADO: orderArray, // Envia a lista de pedidos
      };
  
      // Chama a validação do usuário e o envio do pedido
      await validateUserAndSendOrder(payload);
    } catch (error) {
      console.error('Erro ao processar envio do pedido:', error);
    }
  };
  
  const validateUserAndSendOrder = async (payload) => {
    try {
      // Passo 1: Verificar se o usuário é válido
      const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);
  
      const response = await fetch(`${userInfo.url}/login/v1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`, // Insere o cabeçalho Authorization
        },
      });
  
      if (!response.ok) {
        /*console.error('Erro ao validar usuário:', response.status);*/
        alert('Usuário inválido! Operação cancelada.');
        return;
      }
  
      const data = await response.json();
  
      if (Array.isArray(data) && data.length > 0 && data[0].login === "Login realizado com sucesso!") {
        /*console.log('Usuário válido:', data);*/
  
        // Passo 2: Se válido, prosseguir para o POST
        const postResponse = await fetch(`${userInfo.url}/almoxarifado`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },
          body: JSON.stringify(payload), // Envia o payload como JSON
        });
  
        if (postResponse.ok) {
          const almId = await postResponse.json();
          console.log('ID gerado:', almId);
  
          // Chamar a função para envio de e-mail
          await sendEmail(almId, payload);
  
          alert('Pedido enviado com sucesso!');
          navigate('/menu'); // Redireciona após o envio
        } else {
          console.error('Erro no POST:', postResponse.status);
          alert('Erro ao realizar o POST.');
        }
      } else {
        console.error('Login inválido:', data);
        alert('Usuário inválido! Operação cancelada.');
      }
    } catch (error) {
      console.error('Erro ao validar usuário ou enviar pedido:', error);
      alert('Ocorreu um erro inesperado. Tente novamente.');
    }finally {
    setIsSubmitting(false);
  }
  };
  
  const sendEmail = async (almId, payload) => {
    try {
      const emailPayload = {
        ALM_ID: almId, // Adiciona o ID gerado
        ...payload, // Inclui os dados do POST original
      };
  
      const emailResponse = await fetch(`${userInfo.urlEmail}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(emailPayload), // Envia o e-mail com os dados
        }
      );
  
      if (emailResponse.ok) {
        console.log('E-mail enviado com sucesso!');
      } else {
        console.error('Erro ao enviar e-mail:', emailResponse.status);
      }
    } catch (error) {
      console.error('Erro no envio do e-mail:', error);
    }
  };  
  
  const getUnidadeFormatada = (embUnidade) => {
  if (!embUnidade) return 'Un';

  const unidade = embUnidade.trim().toLowerCase();

  if (unidade === 'sc') return 'KG';
  if (unidade === 'gl') return 'LT';
  if (unidade === 'ga') return 'KG';
  if (unidade === 'bb') return 'KG';

  return embUnidade.toUpperCase(); // fallback
  };

  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h3>Empresa: {userInfo.dpc_id} - {userInfo.company}</h3>
        <h1>Requisição de insumos ao Almoxarifado</h1>

      </header>
      <Link to="/menu" className="link-style">Voltar ao menu</Link>
      <div>
        <label>Selecione aqui o Grupo de produto desejado:</label>
        <select className="selecao" value={selectedGroup} onChange={handleGroupChange}>
          <option value="" >Todos os Produtos</option>
          {groups.map((group) => (
            <option key={group.classe} value={group.classe}>
              {group.classe}
            </option>
          ))}
        </select>
      </div>
      <div className="container">
        <div id="product-list-alm" style={{ display: filteredProducts.length ? 'block' : 'none' }}>
          {filteredProducts.map((product) => (
            <div key={product.id} className="product-item-almoxarifado">
              <span className="product-item-alm">{product.name}</span>
              <div className="quantity-controls-alm">
                <button onClick={() => decrementQuantity(product.id)}>-</button>
                <input
                  type="number"
                value={order[product.id] || 0}
                onChange={(e) => handleQuantityChange(product.id, e.target.value)}
              />
              <span className='embalagem-alm'>{product.embUnidade}</span>
              <button onClick={() => incrementQuantity(product.id)}>+</button>
              <span className="total-volume-alm">
                Total: {(order[product.id] || 0) * (product.volume || 1)} {getUnidadeFormatada(product.embUnidade)}
              </span>
            </div>
          </div>
        ))}
      </div>
      <button id="send-order-alm" onClick={confirmOrder} style={{ marginTop: '20px' }}>
        Ir para Conferência do Pedido
      </button>
    </div>

    {showModal && (
  <div className="modal">
    <div className="modal-content">
      <h2>Confira os itens abaixo, para alterar clique em voltar.</h2>
      <ul className="order-list">
        {orderArray.map((item, index) => (
          <li key={index}>
            <span className="item-name">{item.name}</span>
            <div className="item-quantity">
              <input
                type="number"
                value={item.IALM_QTD}
                onChange={(e) => {
                  const newQuantity = Math.max(parseInt(e.target.value, 10) || 0, 0);
                  const updatedOrderArray = [...orderArray];
                  updatedOrderArray[index].IALM_QTD = newQuantity;
                  setOrderArray(updatedOrderArray);
                }}
                disabled
              />
              <span className="total-volume">
                Total: {item.IALM_QTD / (item.volume || 1)} {item.embUnidade}
              </span>
            </div>
          </li>
        ))}
      </ul>

      <div className="modal-buttons">
        <button onClick={() => setShowModal(false)} className="closeModal">Voltar</button>
        <button
          onClick={sendOrderToAPI}
          className="sendOrder"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Enviando...' : 'Confirmar'}
        </button>
      </div>
    </div>
  </div>
  )}
</>
  );
};

export default Almoxarifado;